import React from 'react';
import { Box, useColorMode } from '@chakra-ui/react';
import logo_light from '../../img/vivai-light-logo.svg';
import logo_dark from '../../img/vivai-dark-logo.svg';
import logo_v_light from '../../img/v-light-logo.svg';
import logo_v_dark from '../../img/v-dark-logo.svg';
import adec_logo from '../../img/adec-logo.svg';

const LogoComponent = ( {isCollapsed, ...props} ) => {
    const { colorMode } = useColorMode();
    const isPartner = window.location.hostname.includes('adec') || window.location.hostname.includes('a-dec');
    const getLogo = () => {
        if (!isCollapsed && isPartner){
            return adec_logo;
        }
        if ( !isCollapsed ){
            return colorMode === 'dark' ? logo_dark : logo_light
        } else {
            return colorMode === 'dark' ? logo_v_dark : logo_v_light
        }
    }
    
    const componentProps = {
      ...props,
      ...((!isCollapsed && isPartner) ? {boxSize: '7rem'} : {})
    };
    
    return (
        <Box
            as="img"
            src={getLogo()}
            alt={isPartner? "partner logo" : "Viva AI Logo"}
            {...componentProps}
        />
    );
};

export default LogoComponent;
